import { render, staticRenderFns } from "./TabsGraficoTorta.vue?vue&type=template&id=26662b7b&"
import script from "./TabsGraficoTorta.vue?vue&type=script&lang=js&"
export * from "./TabsGraficoTorta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports